// Resolve an EventResults submitter (User ID) to a display name from the tenant users list.
const getSubmitterName = (userId, users) => {
    if (!userId) return 'Anoniem'

    const list = Array.isArray(users) ? users : []
    const match = list.find((user) => user.ID === userId)
    if (!match) return 'Anoniem'

    const name = `${match.ForName || ''} ${match.SurName || ''}`.trim()
    return name || 'Anoniem'
}

export default getSubmitterName
